import { colors } from "@mui/material";

function getColor(color, theme) {
	let color_object;
	if (theme && theme.palette[color]) {
		color_object = theme.palette[color];
	} else if (colors[color]) {
		color_object = {
			main: colors[color]["300"],
			light: colors[color]["500"],
			dark: colors[color]["700"],
			contrastText: theme.palette.getContrastText(colors[color]["500"]),
		};
	}
	return color_object;
}

export default getColor;
